import { NetworkActionPrefix, ActionType, SortOrder } from '../utils/constants';
import {
    NewsEntryCategoryApi, NewsEntryEntryStatusApi, NewsEntryUserStatusApi, NewsEntrySourceTypeApi, NewsEntrySourceCategoryApi,
    NewsEntryApi, NewsEntrySourceApi, NewsEntryCommentApi, NewsEntryContributorApi, NewsEntryInsightLinkApi,
    NewsEntryLightReport, NewsEntryContributor, NewsEntryFilter
} from 'for-straction-service-api';
import { networkAPIAction, droppableNetworkAPIAction, entityLifecycleActionSet, nestedEntityLifecycleActionSet } from '../utils/actionCreatorsFactory';
import { isInternalID } from '../api/utils';

const EMPTY_FILTER = NewsEntryFilter.constructFromObject({});

export const loadNewsfeedCategories = () =>
    networkAPIAction(NewsEntryCategoryApi, 'newsEntryCategoryLoadAllGet', NetworkActionPrefix.LOAD_NEWSFEED_CATEGORIES_PREFIX, {});

export const loadNewsfeedEntryStatuses = () =>
    networkAPIAction(NewsEntryEntryStatusApi, 'newsEntryEntryStatusLoadAllGet', NetworkActionPrefix.LOAD_NEWSFEED_ENTRY_STATUSES_PREFIX, {});

export const loadNewsfeedUserStatuses = () =>
    networkAPIAction(NewsEntryUserStatusApi, 'newsEntryUserStatusLoadAllGet', NetworkActionPrefix.LOAD_NEWSFEED_USER_STATUSES_PREFIX, {});

export const loadNewsfeedSourceTypes = () =>
    networkAPIAction(NewsEntrySourceTypeApi, 'newsEntrySourceTypeLoadAllGet', NetworkActionPrefix.LOAD_NEWSFEED_SOURCE_TYPES_PREFIX, {});

export const loadNewsfeedSourceCategories = () =>
    networkAPIAction(NewsEntrySourceCategoryApi, 'newsEntrySourceCategoryLoadAllGet', NetworkActionPrefix.LOAD_NEWSFEED_SOURCE_CATEGORIES_PREFIX, {});



export const searchNewsfeedSourcesSlice = (filter = null, { startID, maxCount, order, excludeNewsless, maxNewsEntriesCount, reset } = {}) =>
    droppableNetworkAPIAction(NewsEntrySourceApi, 'newsEntrySourceSearchMatchingSlicePut', NetworkActionPrefix.SEARCH_NEWSFEED_SOURCES_SLICE_PREFIX, { reset, filter }, filter, { startID, maxCount, order, excludeNewsless, maxNewsEntriesCount });

export const touchAllNewsfeedSources = (sourceIDs) =>
    networkAPIAction(NewsEntrySourceApi, 'newsEntrySourceTouchAllPut', NetworkActionPrefix.TOUCH_ALL_NEWSFEED_SOURCES_PREFIX, { sourceIDs }, sourceIDs);

export const touchNewsfeedSource = (sourceID) =>
    networkAPIAction(NewsEntrySourceApi, 'newsEntrySourceTouchGet', NetworkActionPrefix.TOUCH_NEWSFEED_SOURCE_PREFIX, { sourceID }, sourceID);

export const deleteNewsfeedSource = (sourceID) =>
    networkAPIAction(NewsEntrySourceApi, 'newsEntrySourceDeleteGet', NetworkActionPrefix.DELETE_NEWSFEED_SOURCE_PREFIX, { sourceID }, sourceID);



const withAdditionalPayload = (name, value, action) => {
    if (typeof action === 'object') {
        return { [name]: value, ...action };
    }
    else {
        return dispatch => action(innerAction => dispatch(withAdditionalPayload(name, value, innerAction)));
    }
};

const withNewsfeedKey = (newsfeedKey, action) => withAdditionalPayload('newsfeedKey', newsfeedKey, action);

// dispatches LOAD_NEWS_ENTRY_PENDING before passed action, tries to load the entry after
// TODO handle this in reducers
const wrapSyncWithLoadEntry = (entryID, syncableAction, reloadAfterSync = false, ...reloadArgs) => dispatch => {
    if (reloadAfterSync) {
        dispatch({ type: ActionType.LOAD_NEWSFEED_ENTRY_PENDING, entryID });
    }

    const syncPromise = dispatch(syncableAction);

    if (reloadAfterSync) {
        syncPromise
            .then((response) => dispatch(simpleLoadNewsfeedEntry(entryID || response, ...reloadArgs)))
            .catch(() => dispatch({ type: ActionType.LOAD_NEWSFEED_ENTRY_FAIL, entryID }));
    }
}


export const initializeNewsfeed = (newsfeedKey) => ({ type: ActionType.INITIALIZE_NEWSFEED, newsfeedKey });



const newsEntryActionSet = entityLifecycleActionSet('NewsfeedEntry', 'NEWSFEED_ENTRY', 'entry', NewsEntryApi, {
    load: 'newsEntryLoadLightReportPut',
    add: 'newsEntryAddLightReportPut',
    edit: 'newsEntryEditLightReportPut'
});

const simpleLoadNewsfeedEntry = (entryID, filter = null, { preloadedCommentsCount, commentsOrder, preloadedContributorsCount } = {}) =>
    networkAPIAction(NewsEntryApi, 'newsEntryLoadLightReportPut', NetworkActionPrefix.LOAD_NEWSFEED_ENTRY_PREFIX, { entryID }, filter, entryID, { preloadedCommentsCount, commentsOrder, preloadedContributorsCount });

export const searchNewsfeedEntriesSlice =
    (newsfeedKey, filter = null, { startID, maxCount, sortMode, order, preloadedCommentsCount, commentsOrder, preloadedContributorsCount, skipCountsData, skipDetailedCountsData, countsDataForFilteredOnly }, updateType) =>
        droppableNetworkAPIAction(NewsEntryApi, 'newsEntrySearchLightReportSlicePut', NetworkActionPrefix.SEARCH_NEWSFEED_ENTRIES_SLICE_PREFIX,
            { newsfeedKey, updateType, filter, sortMode }, filter, { startID, maxCount, sortMode, order, preloadedCommentsCount, commentsOrder, preloadedContributorsCount, skipCountsData, skipDetailedCountsData });
export const loadNewsfeedEntry =
    (newsfeedKey, entryID, filter = null, { preloadedCommentsCount, commentsOrder, preloadedContributorsCount } = {}, optimistic = false) =>
        withNewsfeedKey(newsfeedKey, withAdditionalPayload('optimistic', optimistic, simpleLoadNewsfeedEntry(entryID, filter, { preloadedCommentsCount, commentsOrder, preloadedContributorsCount })));
export const addNewsfeedEntry = (newsfeedKey, entry, sync = false, reloadAfterSync = false, filter = null, { preloadedCommentsCount, commentsOrder, preloadedContributorsCount } = {}) =>
    withNewsfeedKey(newsfeedKey, wrapSyncWithLoadEntry(null, newsEntryActionSet.addNewsfeedEntry(entry, sync), reloadAfterSync, filter, { preloadedCommentsCount, commentsOrder, preloadedContributorsCount }));
export const editNewsfeedEntry = (newsfeedKey, entry, sync = false, reloadAfterSync = false, filter = null, { preloadedCommentsCount, commentsOrder, preloadedContributorsCount } = {}) =>
    withNewsfeedKey(newsfeedKey, wrapSyncWithLoadEntry(entry.ID, newsEntryActionSet.editNewsfeedEntry(entry, sync), reloadAfterSync, filter, { preloadedCommentsCount, commentsOrder, preloadedContributorsCount }));
export const syncNewsfeedEntry = (newsfeedKey, entry) =>
    withNewsfeedKey(newsfeedKey, newsEntryActionSet.syncNewsfeedEntry(entry));



const newsfeedCommentActionSet = nestedEntityLifecycleActionSet('NewsfeedComment', 'NEWSFEED_COMMENT', 'entry', 'comment', NewsEntryCommentApi, {
    load: 'newsEntryCommentLoadGet',
    add: 'newsEntryCommentAddPut'
});
const simpleLoadNewsfeedCommentsSlice = (pattern, { startID, maxCount, order } = {}) =>
    networkAPIAction(NewsEntryCommentApi, 'newsEntryCommentSearchSlicePut', NetworkActionPrefix.LOAD_NEWSFEED_COMMENTS_SLICE_PREFIX,
        { entryID: pattern.NewsID }, pattern, { startID, maxCount, order });

export const loadNewsfeedCommentsSlice = (newsfeedKey, pattern, { startID, maxCount, order } = {}) =>
    withNewsfeedKey(newsfeedKey, simpleLoadNewsfeedCommentsSlice(pattern, { startID, maxCount, order }));
export const loadNewsfeedComment = (newsfeedKey, entryID, commentID) =>
    withNewsfeedKey(newsfeedKey, newsfeedCommentActionSet.loadNewsfeedComment(entryID, commentID));
export const addNewsfeedComment =
    (newsfeedKey, entryID, comment, sync = false, reloadAfterSync = false, filter = null, { preloadedCommentsCount, commentsOrder, preloadedContributorsCount } = {}) =>
        withNewsfeedKey(newsfeedKey, wrapSyncWithLoadEntry(entryID, newsfeedCommentActionSet.addNewsfeedComment(entryID, comment, sync), reloadAfterSync, filter, { preloadedCommentsCount, commentsOrder, preloadedContributorsCount }));
export const editNewsfeedComment =
    (newsfeedKey, entryID, comment, sync = false, reloadAfterSync = false, filter = null, { preloadedCommentsCount, commentsOrder, preloadedContributorsCount } = {}) =>
        withNewsfeedKey(newsfeedKey, wrapSyncWithLoadEntry(entryID, newsfeedCommentActionSet.editNewsfeedComment(entryID, comment, sync), reloadAfterSync, filter, { preloadedCommentsCount, commentsOrder, preloadedContributorsCount }));
export const removeNewsfeedComment =
    (newsfeedKey, entryID, commentID, reloadAfterSync = false, filter = null, { preloadedCommentsCount, commentsOrder, preloadedContributorsCount } = {}) =>
        withNewsfeedKey(newsfeedKey, wrapSyncWithLoadEntry(entryID, newsfeedCommentActionSet.removeNewsfeedComment(entryID, commentID), reloadAfterSync, filter, { preloadedCommentsCount, commentsOrder, preloadedContributorsCount }));



const newsfeedContributorActionSet = nestedEntityLifecycleActionSet('NewsfeedContributor', 'NEWSFEED_CONTRIBUTOR', 'entry', 'contributor', NewsEntryContributorApi, {
    load: 'newsEntryContributorLoadGet',
    add: 'newsEntryContributorAddPut',
    edit: 'newsEntryContributorEditPut',
    delete: 'newsEntryContributorDeleteGet'
});

export const loadNewsfeedContributor = (newsfeedKey, entryID, contributorID) =>
    withNewsfeedKey(newsfeedKey, newsfeedContributorActionSet.loadNewsfeedContributor(entryID, contributorID));
export const addNewsfeedContributor =
    (newsfeedKey, entryID, contributor, sync = false, reloadAfterSync = false, filter = null, { preloadedCommentsCount, commentsOrder, preloadedContributorsCount } = {}) =>
        withNewsfeedKey(newsfeedKey, wrapSyncWithLoadEntry(entryID, newsfeedContributorActionSet.addNewsfeedContributor(entryID, contributor, sync), reloadAfterSync, filter, { preloadedCommentsCount, commentsOrder, preloadedContributorsCount }));
export const editNewsfeedContributor =
    (newsfeedKey, entryID, contributor, sync = false, reloadAfterSync = false, filter = null, { preloadedCommentsCount, commentsOrder, preloadedContributorsCount } = {}) =>
        withNewsfeedKey(newsfeedKey, wrapSyncWithLoadEntry(entryID, newsfeedContributorActionSet.editNewsfeedContributor(entryID, contributor, sync), reloadAfterSync, filter, { preloadedCommentsCount, commentsOrder, preloadedContributorsCount }));
export const removeNewsfeedContributor =
    (newsfeedKey, entryID, contributorID, reloadAfterSync = false, filter = null, { preloadedCommentsCount, commentsOrder, preloadedContributorsCount } = {}) =>
        withNewsfeedKey(newsfeedKey, wrapSyncWithLoadEntry(entryID, newsfeedContributorActionSet.removeNewsfeedContributor(entryID, contributorID), reloadAfterSync, filter, { preloadedCommentsCount, commentsOrder, preloadedContributorsCount }));



export const dropNewsfeed = (newsfeedKey) => ({ type: ActionType.DROP_NEWSFEED, newsfeedKey });



export const detectNewsSourceContent = (query) =>
    networkAPIAction(NewsEntrySourceApi, 'newsEntrySourceDetectNewsSourceContentGet', NetworkActionPrefix.DETECT_NEWS_SOURCE_CONTENT_PREFIX, { query }, query);

export const addAllNewsEntryInsightLinks = (newsfeedKey, entryID, newsLinks, sync = false, filter = null) =>
    dispatch => new Promise((resolve, _reject) => {
        dispatch({ type: ActionType.ADD_ALL_NEWS_ENTRY_INSIGHT_LINKS, newsfeedKey, entryID, newsLinks });

        if (!sync) {
            resolve();
        }
        else {
            withNewsfeedKey(newsfeedKey, wrapSyncWithLoadEntry(entryID,
                dispatch(networkAPIAction(NewsEntryInsightLinkApi, 'newsEntryInsightLinkAddAllPut', NetworkActionPrefix.ADD_ALL_NEWS_ENTRY_INSIGHT_LINKS_PREFIX, { newsfeedKey, entryID, newsLinks }, newsLinks)),
                sync, filter));
        }
    });

export const removeAllNewsEntryInsightLinks = (newsfeedKey, entryID, newsLinkIDs, reloadAfterSync = false, filter = null) =>
    (dispatch) => {
        dispatch({ type: ActionType.DELETE_ALL_NEWS_ENTRY_INSIGHT_LINKS, newsfeedKey, entryID, newsLinkIDs });

        withNewsfeedKey(newsfeedKey, wrapSyncWithLoadEntry(entryID,
            dispatch(networkAPIAction(NewsEntryInsightLinkApi, 'newsEntryInsightLinkDeleteAllPut', NetworkActionPrefix.DELETE_ALL_NEWS_ENTRY_INSIGHT_LINKS_PREFIX, { newsfeedKey, entryID, newsLinkIDs }, newsLinkIDs)),
            reloadAfterSync, filter));
    };